import { takeLatest, put } from "redux-saga/effects"
import types from "constants/action-types"
import { setgroups, setCategories, setRegions, setLoading } from "./actions"
import groups from "services/groups"
import regions from "services/regions"
import categories from "services/categories"

function* fetchData() {
  try {
    yield put(setLoading(true))
    const groupsData = yield groups.getAll()
    yield put(setgroups(groupsData))
    const catsData = yield categories.getAll()
    yield put(setCategories(catsData))
    const regionsData = yield regions.getAll()
    yield put(setRegions(regionsData))
    yield put(setLoading(false))
  } catch (error) {
    yield put(setLoading(false))
    console.log("error", error)
  }
}

export default function* commonsSaga() {
  yield takeLatest(types.APPLICATION_FETCH_COMMONS_DATA, fetchData)
}
